import React, {useEffect, useState} from 'react';
import {AuthLayout} from "../../../core/layout/AuthLayout";
import http from "../../../shared/utils/http";
import {useAppDispatch} from "../../../app/hooks";
import {
    loadEmployeesAction,
    resetPharmacies, resetPharmacistEmployeesLimit,
    setPharmacies,
    setSelectedPharmacist
} from "../../../core/reducer/auth/authSlice";
import {resetEmployees, resetSelectedPharmacy, selectedPharmacyAction} from "../../../core/reducer/pharmacySlice";
import Table from "../../../shared/ui/table/table/Table";
import {TableData, TemplateTable} from "../../../shared/ui/table/models/TableProps";
import {useRoute} from "../../../core/routes/useRoute";
import {nameRoutes} from "../../../core/routes/nameRoutes";


export function Pharmacists() {
    const [pharmacists, setPharmacists] = useState<any[]>([])
    const dispatch = useAppDispatch()
    const {changeRoute} = useRoute()

    useEffect(() => {
        http.get('pharmacists').then(res => {
            setPharmacists(res.pharmacists)
        })
    }, []);
    const selPharmacists = (pharmacist: any) => {
        http.get(`pharmacists/${pharmacist.idDocument}/pharmacies`).then((res) => {
            dispatch(resetPharmacies())
            dispatch(resetEmployees())
            dispatch(resetSelectedPharmacy())
            dispatch(resetPharmacistEmployeesLimit())
            dispatch(setSelectedPharmacist(pharmacist.idDocument))
            dispatch(setPharmacies(res.pharmacies))
            res.pharmacies.length && dispatch(selectedPharmacyAction(res.pharmacies[0]))
            dispatch(loadEmployeesAction(() => changeRoute(nameRoutes.calendar)))
        })
    }

    const tableStructureEmployees: TableData[] = [
        {
            name: "surname",
            label: "Cognome",
        },
        {
            name: "name",
            label: "Nome",
        },
        {
            name: "type",
            label: "Tipo Utente",
        },
        {
            name: "employees",
            label: "# Massimo Dipendenti",
        },
        {
            name: "email",
            label: "Email",
        },

    ];
    const templates: TemplateTable = {}

    return (
        <AuthLayout>
            <div className="row pt-3">
                <div className="col-12">
                    <div className={'d-flex justify-content-between align-items-center'}>
                        <h3>Lista Farmacisti</h3>
                    </div>
                </div>
                <div className="col-12 list-container">
                    <Table columns={tableStructureEmployees} data={pharmacists}
                           templates={templates} rowIndexActive={['0']} clickRow={(e, row) => selPharmacists(row)}/>
                </div>
            </div>
        </AuthLayout>
    );
}


